import { Box, Typography, Stack, Paper, Divider } from "@mui/material";
import Grid from "@mui/material/Grid2";
import PersonIcon from "@mui/icons-material/Person";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import DescriptionIcon from "@mui/icons-material/Description";
import WorkIcon from "@mui/icons-material/Work";
import ModernCard from "./ModernCard";
import PropTypes from "prop-types";

const PermitInfoCard = ({ workPermit, convertUTCToLocal, t }) => (
  <ModernCard
    title={t("documentDetail.permitInfoTitle")}
    icon={DescriptionIcon}
  >
    <Grid container spacing={3}>
      <Grid size={{ xs: 12, md: 6 }}>
        <Stack spacing={2}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <PersonIcon sx={{ color: "text.secondary", fontSize: 20 }} />
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box sx={{ minWidth: 120 }}>
                <Typography variant="body1" component="span">
                  <strong>{t("documentDetail.requestedByLabel")}:</strong>
                </Typography>
              </Box>
              <Typography variant="body1" component="span">
                {`${workPermit.author?.first_name} ${workPermit.author?.last_name}`}
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <LocationOnIcon sx={{ color: "text.secondary", fontSize: 20 }} />
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box sx={{ minWidth: 120 }}>
                <Typography variant="body1" component="span">
                  <strong>{t("documentDetail.siteLabel")}:</strong>
                </Typography>
              </Box>
              <Typography variant="body1" component="span">
                {workPermit.site?.name || t("documentDetail.na")}
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <AccessTimeIcon sx={{ color: "text.secondary", fontSize: 20 }} />
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box sx={{ minWidth: 120 }}>
                <Typography variant="body1" component="span">
                  <strong>{t("documentDetail.startTimeLabel")}:</strong>
                </Typography>
              </Box>
              <Typography variant="body1" component="span">
                {convertUTCToLocal(workPermit.start_timestamp)}
              </Typography>
            </Box>
          </Box>
        </Stack>
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Stack spacing={2}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <DescriptionIcon sx={{ color: "text.secondary", fontSize: 20 }} />
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box sx={{ minWidth: 120 }}>
                <Typography variant="body1" component="span">
                  <strong>{t("documentDetail.titleLabel")}:</strong>
                </Typography>
              </Box>
              <Typography variant="body1" component="span">
                {workPermit.title || t("documentDetail.na")}
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <WorkIcon sx={{ color: "text.secondary", fontSize: 20 }} />
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box sx={{ minWidth: 120 }}>
                <Typography variant="body1" component="span">
                  <strong>{t("documentDetail.workTypeLabel")}:</strong>
                </Typography>
              </Box>
              <Typography variant="body1" component="span">
                {workPermit.workflow?.name || t("documentDetail.na")}
              </Typography>
            </Box>
          </Box>
        </Stack>
      </Grid>

      <Grid size={12}>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>
          {t("documentDetail.descriptionLabel")}:
        </Typography>
        <Paper variant="outlined" sx={{ p: 2, bgcolor: "background.paper" }}>
          <Typography variant="body1" sx={{ whiteSpace: "pre-line" }}>
            {workPermit.description || t("documentDetail.noDescription")}
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  </ModernCard>
);

PermitInfoCard.propTypes = {
  workPermit: PropTypes.object.isRequired,
  convertUTCToLocal: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default PermitInfoCard;
